export type ChargeStrategy = 'now' | 'delayed' | 'deactivated'
export enum KeyLockModes {
  Lock = 'lock',
  Sun = 'sun',
}

export type KeyLockMode = `${KeyLockModes}`

export enum ChargeStrategyEnum {
  now = 'now',
  delayed = 'delayed',
  deactivated = 'deactivated',
}

export interface WallboxCurrentOverview {
  SUN: number
  NET: number
  carConnected: boolean
}

export interface Weekday {
  /**
   * Daytime in seconds after midnight. e.g. 3600 = 01:00
   */
  daytime: number

  /**
   * energy values as wH. Therefor kwH with factor 1000
   */
  minEnergy: number
}

export enum WallboxType {
  DefaultE3dc = 1 /** E3DC Wallbox */,
  EasyConnect = 2,
  OCPP = 3,
  Farm = 4,
  Bidi = 5 /** Edison Connect */,
  MultiConnect = 6 /** Multi Connect 1 & 2 */,
  Efy = 8 /** Called Witty in Hager/Flow Context */,
  EDSN = 11 /** EDSN */,
}
